/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as NetworkExplorerRouteImport } from './routes/network-explorer'
import { Route as R404RouteImport } from './routes/404'
import { Route as SaviRouteRouteImport } from './routes/savi/route'
import { Route as FindAndFixRouteRouteImport } from './routes/find-and-fix/route'
import { Route as IndexRouteImport } from './routes/index'
import { Route as SaviIndexRouteImport } from './routes/savi/index'
import { Route as FindAndFixIndexRouteImport } from './routes/find-and-fix/index'
import { Route as SaviNetworkOverviewRouteImport } from './routes/savi/network-overview'
import { Route as FindAndFixNetworkOverviewRouteImport } from './routes/find-and-fix/network-overview'
import { Route as SaviAssetAssetIdRouteImport } from './routes/savi/asset/$assetId'
import { Route as FindAndFixPoiPoiIdRouteRouteImport } from './routes/find-and-fix/poi/$poiId/route'
import { Route as FindAndFixPoiPoiIdIndexRouteImport } from './routes/find-and-fix/poi/$poiId/index'
import { Route as FindAndFixPoiPoiIdRecheckRouteImport } from './routes/find-and-fix/poi/$poiId/recheck'
import { Route as FindAndFixPoiPoiIdPipelinesRouteImport } from './routes/find-and-fix/poi/$poiId/pipelines'
import { Route as FindAndFixPoiPoiIdLeakRouteImport } from './routes/find-and-fix/poi/$poiId/leak'
import { Route as FindAndFixPoiPoiIdHistoryRouteImport } from './routes/find-and-fix/poi/$poiId/history'
import { Route as FindAndFixPoiPoiIdDetailsRouteImport } from './routes/find-and-fix/poi/$poiId/details'

const NetworkExplorerRoute = NetworkExplorerRouteImport.update({
  id: '/network-explorer',
  path: '/network-explorer',
  getParentRoute: () => rootRouteImport,
} as any)
const R404Route = R404RouteImport.update({
  id: '/404',
  path: '/404',
  getParentRoute: () => rootRouteImport,
} as any)
const SaviRouteRoute = SaviRouteRouteImport.update({
  id: '/savi',
  path: '/savi',
  getParentRoute: () => rootRouteImport,
} as any)
const FindAndFixRouteRoute = FindAndFixRouteRouteImport.update({
  id: '/find-and-fix',
  path: '/find-and-fix',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const SaviIndexRoute = SaviIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => SaviRouteRoute,
} as any)
const FindAndFixIndexRoute = FindAndFixIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => FindAndFixRouteRoute,
} as any)
const SaviNetworkOverviewRoute = SaviNetworkOverviewRouteImport.update({
  id: '/network-overview',
  path: '/network-overview',
  getParentRoute: () => SaviRouteRoute,
} as any)
const FindAndFixNetworkOverviewRoute =
  FindAndFixNetworkOverviewRouteImport.update({
    id: '/network-overview',
    path: '/network-overview',
    getParentRoute: () => FindAndFixRouteRoute,
  } as any)
const SaviAssetAssetIdRoute = SaviAssetAssetIdRouteImport.update({
  id: '/asset/$assetId',
  path: '/asset/$assetId',
  getParentRoute: () => SaviRouteRoute,
} as any)
const FindAndFixPoiPoiIdRouteRoute = FindAndFixPoiPoiIdRouteRouteImport.update({
  id: '/poi/$poiId',
  path: '/poi/$poiId',
  getParentRoute: () => FindAndFixRouteRoute,
} as any)
const FindAndFixPoiPoiIdIndexRoute = FindAndFixPoiPoiIdIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => FindAndFixPoiPoiIdRouteRoute,
} as any)
const FindAndFixPoiPoiIdRecheckRoute =
  FindAndFixPoiPoiIdRecheckRouteImport.update({
    id: '/recheck',
    path: '/recheck',
    getParentRoute: () => FindAndFixPoiPoiIdRouteRoute,
  } as any)
const FindAndFixPoiPoiIdPipelinesRoute =
  FindAndFixPoiPoiIdPipelinesRouteImport.update({
    id: '/pipelines',
    path: '/pipelines',
    getParentRoute: () => FindAndFixPoiPoiIdRouteRoute,
  } as any)
const FindAndFixPoiPoiIdLeakRoute = FindAndFixPoiPoiIdLeakRouteImport.update({
  id: '/leak',
  path: '/leak',
  getParentRoute: () => FindAndFixPoiPoiIdRouteRoute,
} as any)
const FindAndFixPoiPoiIdHistoryRoute =
  FindAndFixPoiPoiIdHistoryRouteImport.update({
    id: '/history',
    path: '/history',
    getParentRoute: () => FindAndFixPoiPoiIdRouteRoute,
  } as any)
const FindAndFixPoiPoiIdDetailsRoute =
  FindAndFixPoiPoiIdDetailsRouteImport.update({
    id: '/details',
    path: '/details',
    getParentRoute: () => FindAndFixPoiPoiIdRouteRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/find-and-fix': typeof FindAndFixRouteRouteWithChildren
  '/savi': typeof SaviRouteRouteWithChildren
  '/404': typeof R404Route
  '/network-explorer': typeof NetworkExplorerRoute
  '/find-and-fix/network-overview': typeof FindAndFixNetworkOverviewRoute
  '/savi/network-overview': typeof SaviNetworkOverviewRoute
  '/find-and-fix/': typeof FindAndFixIndexRoute
  '/savi/': typeof SaviIndexRoute
  '/find-and-fix/poi/$poiId': typeof FindAndFixPoiPoiIdRouteRouteWithChildren
  '/savi/asset/$assetId': typeof SaviAssetAssetIdRoute
  '/find-and-fix/poi/$poiId/details': typeof FindAndFixPoiPoiIdDetailsRoute
  '/find-and-fix/poi/$poiId/history': typeof FindAndFixPoiPoiIdHistoryRoute
  '/find-and-fix/poi/$poiId/leak': typeof FindAndFixPoiPoiIdLeakRoute
  '/find-and-fix/poi/$poiId/pipelines': typeof FindAndFixPoiPoiIdPipelinesRoute
  '/find-and-fix/poi/$poiId/recheck': typeof FindAndFixPoiPoiIdRecheckRoute
  '/find-and-fix/poi/$poiId/': typeof FindAndFixPoiPoiIdIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/404': typeof R404Route
  '/network-explorer': typeof NetworkExplorerRoute
  '/find-and-fix/network-overview': typeof FindAndFixNetworkOverviewRoute
  '/savi/network-overview': typeof SaviNetworkOverviewRoute
  '/find-and-fix': typeof FindAndFixIndexRoute
  '/savi': typeof SaviIndexRoute
  '/savi/asset/$assetId': typeof SaviAssetAssetIdRoute
  '/find-and-fix/poi/$poiId/details': typeof FindAndFixPoiPoiIdDetailsRoute
  '/find-and-fix/poi/$poiId/history': typeof FindAndFixPoiPoiIdHistoryRoute
  '/find-and-fix/poi/$poiId/leak': typeof FindAndFixPoiPoiIdLeakRoute
  '/find-and-fix/poi/$poiId/pipelines': typeof FindAndFixPoiPoiIdPipelinesRoute
  '/find-and-fix/poi/$poiId/recheck': typeof FindAndFixPoiPoiIdRecheckRoute
  '/find-and-fix/poi/$poiId': typeof FindAndFixPoiPoiIdIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/find-and-fix': typeof FindAndFixRouteRouteWithChildren
  '/savi': typeof SaviRouteRouteWithChildren
  '/404': typeof R404Route
  '/network-explorer': typeof NetworkExplorerRoute
  '/find-and-fix/network-overview': typeof FindAndFixNetworkOverviewRoute
  '/savi/network-overview': typeof SaviNetworkOverviewRoute
  '/find-and-fix/': typeof FindAndFixIndexRoute
  '/savi/': typeof SaviIndexRoute
  '/find-and-fix/poi/$poiId': typeof FindAndFixPoiPoiIdRouteRouteWithChildren
  '/savi/asset/$assetId': typeof SaviAssetAssetIdRoute
  '/find-and-fix/poi/$poiId/details': typeof FindAndFixPoiPoiIdDetailsRoute
  '/find-and-fix/poi/$poiId/history': typeof FindAndFixPoiPoiIdHistoryRoute
  '/find-and-fix/poi/$poiId/leak': typeof FindAndFixPoiPoiIdLeakRoute
  '/find-and-fix/poi/$poiId/pipelines': typeof FindAndFixPoiPoiIdPipelinesRoute
  '/find-and-fix/poi/$poiId/recheck': typeof FindAndFixPoiPoiIdRecheckRoute
  '/find-and-fix/poi/$poiId/': typeof FindAndFixPoiPoiIdIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/find-and-fix'
    | '/savi'
    | '/404'
    | '/network-explorer'
    | '/find-and-fix/network-overview'
    | '/savi/network-overview'
    | '/find-and-fix/'
    | '/savi/'
    | '/find-and-fix/poi/$poiId'
    | '/savi/asset/$assetId'
    | '/find-and-fix/poi/$poiId/details'
    | '/find-and-fix/poi/$poiId/history'
    | '/find-and-fix/poi/$poiId/leak'
    | '/find-and-fix/poi/$poiId/pipelines'
    | '/find-and-fix/poi/$poiId/recheck'
    | '/find-and-fix/poi/$poiId/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/404'
    | '/network-explorer'
    | '/find-and-fix/network-overview'
    | '/savi/network-overview'
    | '/find-and-fix'
    | '/savi'
    | '/savi/asset/$assetId'
    | '/find-and-fix/poi/$poiId/details'
    | '/find-and-fix/poi/$poiId/history'
    | '/find-and-fix/poi/$poiId/leak'
    | '/find-and-fix/poi/$poiId/pipelines'
    | '/find-and-fix/poi/$poiId/recheck'
    | '/find-and-fix/poi/$poiId'
  id:
    | '__root__'
    | '/'
    | '/find-and-fix'
    | '/savi'
    | '/404'
    | '/network-explorer'
    | '/find-and-fix/network-overview'
    | '/savi/network-overview'
    | '/find-and-fix/'
    | '/savi/'
    | '/find-and-fix/poi/$poiId'
    | '/savi/asset/$assetId'
    | '/find-and-fix/poi/$poiId/details'
    | '/find-and-fix/poi/$poiId/history'
    | '/find-and-fix/poi/$poiId/leak'
    | '/find-and-fix/poi/$poiId/pipelines'
    | '/find-and-fix/poi/$poiId/recheck'
    | '/find-and-fix/poi/$poiId/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  FindAndFixRouteRoute: typeof FindAndFixRouteRouteWithChildren
  SaviRouteRoute: typeof SaviRouteRouteWithChildren
  R404Route: typeof R404Route
  NetworkExplorerRoute: typeof NetworkExplorerRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/network-explorer': {
      id: '/network-explorer'
      path: '/network-explorer'
      fullPath: '/network-explorer'
      preLoaderRoute: typeof NetworkExplorerRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/404': {
      id: '/404'
      path: '/404'
      fullPath: '/404'
      preLoaderRoute: typeof R404RouteImport
      parentRoute: typeof rootRouteImport
    }
    '/savi': {
      id: '/savi'
      path: '/savi'
      fullPath: '/savi'
      preLoaderRoute: typeof SaviRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/find-and-fix': {
      id: '/find-and-fix'
      path: '/find-and-fix'
      fullPath: '/find-and-fix'
      preLoaderRoute: typeof FindAndFixRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/savi/': {
      id: '/savi/'
      path: '/'
      fullPath: '/savi/'
      preLoaderRoute: typeof SaviIndexRouteImport
      parentRoute: typeof SaviRouteRoute
    }
    '/find-and-fix/': {
      id: '/find-and-fix/'
      path: '/'
      fullPath: '/find-and-fix/'
      preLoaderRoute: typeof FindAndFixIndexRouteImport
      parentRoute: typeof FindAndFixRouteRoute
    }
    '/savi/network-overview': {
      id: '/savi/network-overview'
      path: '/network-overview'
      fullPath: '/savi/network-overview'
      preLoaderRoute: typeof SaviNetworkOverviewRouteImport
      parentRoute: typeof SaviRouteRoute
    }
    '/find-and-fix/network-overview': {
      id: '/find-and-fix/network-overview'
      path: '/network-overview'
      fullPath: '/find-and-fix/network-overview'
      preLoaderRoute: typeof FindAndFixNetworkOverviewRouteImport
      parentRoute: typeof FindAndFixRouteRoute
    }
    '/savi/asset/$assetId': {
      id: '/savi/asset/$assetId'
      path: '/asset/$assetId'
      fullPath: '/savi/asset/$assetId'
      preLoaderRoute: typeof SaviAssetAssetIdRouteImport
      parentRoute: typeof SaviRouteRoute
    }
    '/find-and-fix/poi/$poiId': {
      id: '/find-and-fix/poi/$poiId'
      path: '/poi/$poiId'
      fullPath: '/find-and-fix/poi/$poiId'
      preLoaderRoute: typeof FindAndFixPoiPoiIdRouteRouteImport
      parentRoute: typeof FindAndFixRouteRoute
    }
    '/find-and-fix/poi/$poiId/': {
      id: '/find-and-fix/poi/$poiId/'
      path: '/'
      fullPath: '/find-and-fix/poi/$poiId/'
      preLoaderRoute: typeof FindAndFixPoiPoiIdIndexRouteImport
      parentRoute: typeof FindAndFixPoiPoiIdRouteRoute
    }
    '/find-and-fix/poi/$poiId/recheck': {
      id: '/find-and-fix/poi/$poiId/recheck'
      path: '/recheck'
      fullPath: '/find-and-fix/poi/$poiId/recheck'
      preLoaderRoute: typeof FindAndFixPoiPoiIdRecheckRouteImport
      parentRoute: typeof FindAndFixPoiPoiIdRouteRoute
    }
    '/find-and-fix/poi/$poiId/pipelines': {
      id: '/find-and-fix/poi/$poiId/pipelines'
      path: '/pipelines'
      fullPath: '/find-and-fix/poi/$poiId/pipelines'
      preLoaderRoute: typeof FindAndFixPoiPoiIdPipelinesRouteImport
      parentRoute: typeof FindAndFixPoiPoiIdRouteRoute
    }
    '/find-and-fix/poi/$poiId/leak': {
      id: '/find-and-fix/poi/$poiId/leak'
      path: '/leak'
      fullPath: '/find-and-fix/poi/$poiId/leak'
      preLoaderRoute: typeof FindAndFixPoiPoiIdLeakRouteImport
      parentRoute: typeof FindAndFixPoiPoiIdRouteRoute
    }
    '/find-and-fix/poi/$poiId/history': {
      id: '/find-and-fix/poi/$poiId/history'
      path: '/history'
      fullPath: '/find-and-fix/poi/$poiId/history'
      preLoaderRoute: typeof FindAndFixPoiPoiIdHistoryRouteImport
      parentRoute: typeof FindAndFixPoiPoiIdRouteRoute
    }
    '/find-and-fix/poi/$poiId/details': {
      id: '/find-and-fix/poi/$poiId/details'
      path: '/details'
      fullPath: '/find-and-fix/poi/$poiId/details'
      preLoaderRoute: typeof FindAndFixPoiPoiIdDetailsRouteImport
      parentRoute: typeof FindAndFixPoiPoiIdRouteRoute
    }
  }
}

interface FindAndFixPoiPoiIdRouteRouteChildren {
  FindAndFixPoiPoiIdDetailsRoute: typeof FindAndFixPoiPoiIdDetailsRoute
  FindAndFixPoiPoiIdHistoryRoute: typeof FindAndFixPoiPoiIdHistoryRoute
  FindAndFixPoiPoiIdLeakRoute: typeof FindAndFixPoiPoiIdLeakRoute
  FindAndFixPoiPoiIdPipelinesRoute: typeof FindAndFixPoiPoiIdPipelinesRoute
  FindAndFixPoiPoiIdRecheckRoute: typeof FindAndFixPoiPoiIdRecheckRoute
  FindAndFixPoiPoiIdIndexRoute: typeof FindAndFixPoiPoiIdIndexRoute
}

const FindAndFixPoiPoiIdRouteRouteChildren: FindAndFixPoiPoiIdRouteRouteChildren =
  {
    FindAndFixPoiPoiIdDetailsRoute: FindAndFixPoiPoiIdDetailsRoute,
    FindAndFixPoiPoiIdHistoryRoute: FindAndFixPoiPoiIdHistoryRoute,
    FindAndFixPoiPoiIdLeakRoute: FindAndFixPoiPoiIdLeakRoute,
    FindAndFixPoiPoiIdPipelinesRoute: FindAndFixPoiPoiIdPipelinesRoute,
    FindAndFixPoiPoiIdRecheckRoute: FindAndFixPoiPoiIdRecheckRoute,
    FindAndFixPoiPoiIdIndexRoute: FindAndFixPoiPoiIdIndexRoute,
  }

const FindAndFixPoiPoiIdRouteRouteWithChildren =
  FindAndFixPoiPoiIdRouteRoute._addFileChildren(
    FindAndFixPoiPoiIdRouteRouteChildren,
  )

interface FindAndFixRouteRouteChildren {
  FindAndFixNetworkOverviewRoute: typeof FindAndFixNetworkOverviewRoute
  FindAndFixIndexRoute: typeof FindAndFixIndexRoute
  FindAndFixPoiPoiIdRouteRoute: typeof FindAndFixPoiPoiIdRouteRouteWithChildren
}

const FindAndFixRouteRouteChildren: FindAndFixRouteRouteChildren = {
  FindAndFixNetworkOverviewRoute: FindAndFixNetworkOverviewRoute,
  FindAndFixIndexRoute: FindAndFixIndexRoute,
  FindAndFixPoiPoiIdRouteRoute: FindAndFixPoiPoiIdRouteRouteWithChildren,
}

const FindAndFixRouteRouteWithChildren = FindAndFixRouteRoute._addFileChildren(
  FindAndFixRouteRouteChildren,
)

interface SaviRouteRouteChildren {
  SaviNetworkOverviewRoute: typeof SaviNetworkOverviewRoute
  SaviIndexRoute: typeof SaviIndexRoute
  SaviAssetAssetIdRoute: typeof SaviAssetAssetIdRoute
}

const SaviRouteRouteChildren: SaviRouteRouteChildren = {
  SaviNetworkOverviewRoute: SaviNetworkOverviewRoute,
  SaviIndexRoute: SaviIndexRoute,
  SaviAssetAssetIdRoute: SaviAssetAssetIdRoute,
}

const SaviRouteRouteWithChildren = SaviRouteRoute._addFileChildren(
  SaviRouteRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  FindAndFixRouteRoute: FindAndFixRouteRouteWithChildren,
  SaviRouteRoute: SaviRouteRouteWithChildren,
  R404Route: R404Route,
  NetworkExplorerRoute: NetworkExplorerRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
